// extracted by mini-css-extract-plugin
export default {"principal":"homepage_principal__8jrGt","principal__imagem":"homepage_principal__imagem__Iw-kt","conteudo":"homepage_conteudo__cAhYY"};